import React from 'react'; //Um import que parece não ser utilizado, mas é sim
import './assets/styles/global.css';
import Routes from './routes';


//JSX -JavaScript + XML
//      \/ O componente deve ter a primeira letra maiúscula, para que não confunda com uma tag XML
function App() {
  return( 
    <Routes />
  );
}

export default App;